import React from 'react';

const SelectField = React.forwardRef(({ label, options, placeholder, error, className = "", ...props }, ref) => {
  return (
    <div className={className}>
      <label className="block text-sm text-darkGray mb-1">
        {label}
      </label>
      <div className="relative">
        <select
          ref={ref}
          className="w-full border border-secondary rounded-xl px-3 py-2 text-darkGray focus:outline-none"
          {...props}
        >
          <option value="" disabled>{placeholder}</option>
          {options.map((opt) => (
            <option key={opt.value} value={opt.value}>
              {opt.label}
            </option>
          ))}
        </select>
      </div>
    </div>
  );
});

export default SelectField;